import { theme } from "../theme";

// @ts-ignore
// tslint:disable-next-line
export const colorSelector = (colorName: string) => (theme.colors as any)[colorName] || colorName;
